import { useEffect, useState } from "react";

export function QuestionExamTimerBox({
  onAutoSubmit,
  totalQuestions,
}: {
  onAutoSubmit: () => void;
  totalQuestions: number;
}) {
  // Set 1 minute per question
  const [timeLeft, setTimeLeft] = useState(totalQuestions * 60);

  useEffect(() => {
    if (timeLeft <= 0) {
      onAutoSubmit(); // auto submit
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, onAutoSubmit]);

  // Format to HH:MM:SS
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const m = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  return (
    <div className="surface-card border-round p-3 shadow-1 w-full text-center mb-4">
      <h4 className="text-sm mb-2">Remaining Time</h4>

      <div className="text-xl font-bold">{formatTime(timeLeft)}</div>
    </div>
  );
}
